import {auth, firebase as Firebase} from '../firebase';
import * as actions from '../actions';
import * as rootObject from '../reducers';
import { Equal } from '../Utils';

const DEFAULT_USER = {
	id: null,
	name: null,
	email: null,
}


export const getState = () => JSON.parse(localStorage.getItem('state') || "{}");

export const saveState = (state) => {
	try {
		localStorage.setItem('state', JSON.stringify(state))
	} catch (err) {

	}
}

export const firebase = (store)=>{
	onConnectionStateChange(conn=>store.dispatch(actions.doConnectionState(conn)))
		

	auth.onStateChange(authUser => { 
		const {uid,displayname,email} = authUser ? authUser : DEFAULT_USER;
		const cars = state => rootObject.getCars(state)

		//if Firebase user is different from Redux user, reset Redux
		if(!Equal(rootObject.getUser(store.getState()).id , uid)){
			
			store.dispatch(actions.signIn(uid,displayname,email));

		}

		//if Firebase database is different from Redux store, reset Redux
		if(uid){
			const carsRef = Firebase.db.ref(uid+'/cars');
			store.subscribe(()=>{
				carsRef.set( cars(store.getState()) );
			})
			carsRef.on('value', snapshot=>{
				if(!Equal( cars(store.getState()) , snapshot.val() )){
				
					store.dispatch(actions.initApp(snapshot.val()))
				}
			});
		}
	});
}

export const onConnectionStateChange = (cb)=>{
	

	const connectedRef = Firebase.db.ref('.info/connected');
			connectedRef.on('value', function(snap) {
			  cb(snap.val());
			});


	
}

export const firebase2 = () => {
	//Firebase.db.ref("my_id").set( {cars:"object later",locked:false} );
	// const lastOnlineRef = Firebase.db.ref('my_id/locked');
	


}




// WEBPACK FOOTER //
// ./src/storage/index.js